import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useUser } from '../context/UserContext';
import { CircularProgress, Box } from '@mui/material';

const PrivateRoute = ({ children }) => {
  const { currentUser, loading: authLoading } = useAuth();
  const { isOnboarded, loading: userLoading } = useUser();
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  
  // Add this effect to ensure initialLoadComplete gets set
  useEffect(() => {
    console.log("PrivateRoute effect running with:", { 
      authLoading, userLoading, currentUser, initialLoadComplete 
    });
    
    // If authentication is done (either logged in or not)
    if (!authLoading) {
      // Force initialLoadComplete to true even if no user
      setInitialLoadComplete(true);
    }
  }, [authLoading, userLoading, currentUser]);
  
  // Set a timeout to force completion after 5 seconds
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!initialLoadComplete) {
        console.log("Loading timeout reached, forcing completion");
        setInitialLoadComplete(true);
      }
    }, 5000);
    
    return () => clearTimeout(timeoutId);
  }, [initialLoadComplete]);
  
  // Show loading only during authentication
  if (authLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress size={40} />
        <Box mt={2}>Loading authentication...</Box>
      </Box>
    );
  }
  
  // If not logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  // If all checks pass, render the protected component
  return children;
};

export default PrivateRoute;